import 'aos/dist/aos.css';
import AOS from 'aos';
import { useEffect } from 'react';
import LandingPage from './pages/LandingPage';

export default function App() {
  useEffect(() => {
    AOS.init({
      once: true, // animate only once
      duration: 800,
    });
  }, []);
  
  return <LandingPage/>;
}
